import styled from '@emotion/styled';

interface Props {
  imageUrl: string;
  handleBannerClick: () => void;
}
export const DescriptionTopBanner: React.FC<React.PropsWithChildren<Props>> = ({ imageUrl, handleBannerClick }) => {
  return (
    <Container>
      <img src={imageUrl} onClick={handleBannerClick} alt='배너 이미지' />
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px;

  img {
    border-radius: 8px;
  }
`;
